module.exports = __webpack_public_path__ + "img/brokers_hero_mobile.aa7fa61b.jpg";